import Cookies from "universal-cookie";


const cookies = new Cookies();

export function setPartnerCookie(partnerParams: string | null | undefined): boolean {
  const COOKIE_NAME = "partner";

  if (!partnerParams || partnerParams.trim() === "") {
    return false;
  }

  try {
    cookies.set(COOKIE_NAME, partnerParams, {
      path: "/",
      maxAge: undefined,
      secure: true,
      sameSite: "lax",
    });

    return true;
  } catch (error) {
    console.error("Failed to set partner cookie:", error);
    return false;
  }
}

export function getPartnerCookie(): string {
  const COOKIE_NAME = "partner";

  try {
    return cookies.get(COOKIE_NAME) ?? "PAPER";
  } catch (error) {
    console.error("Failed to get partner cookie:", error);
    return "PAPER";
  }
}